<form #form="ngForm" class="container-form" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="form-group col-12 col-md-6 col-xl-3">
                            <label for="codigo" class="col-form-label">Código</label>
                            <input type="number" class="form-control" [value]="entity.codigo" name="codigo" id="codigo"
                                disabled="disabled" readonly="readonly">
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" name="codigoIntegracaoErp" id="codigoIntegracaoErp"
                                #codigoIntegracaoErp="ngModel" maxlength="50">
                            <p class="form-text text-muted">Código do mercado no seu sistema ERP</p>                                
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="nome" class="col-form-label">Nome</label>
                    <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                        #nome="ngModel" required="required" maxlength="255" [autofocus]="true">
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.required && nome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error>
                    <sgt-form-control-error
                        *ngIf="nome.errors && nome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6 col-xl-3">
                    <label for="situacao" class="col-form-label">Situação</label>
                    <select class="form-control" name="situacao" id="situacao"
                        [ngModel]="entity.situacao || ''" (ngModelChange)="entity.situacao = $event"
                        #situacao="ngModel" required="required">
                        <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                    </select>
                    <sgt-form-control-error
                        *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                        msgError="A situação é obrigatória">
                    </sgt-form-control-error>
                </div>
            </div>

            <div class="row" *ngIf="entity.unidadeNegocio">
                <div class="form-group col-12">
                    <label class="col-form-label">Unidade de Negócio</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                {{entity.unidadeNegocio.codigoIntegracaoErp}}
                            </span>
                        </div>
                        <input type="text" class="form-control" [value]="entity.unidadeNegocio.nome" disabled="disable" readonly="readonly">
                    </div>
                    <p class="form-text text-muted">Unidade de negócio vinculada a este mercado</p>
                </div>
            </div>

            <div class="row" *ngIf="entity.itemTipo">
                <div class="form-group col-12">
                    <label class="col-form-label">Tipo de Produto</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                {{entity.itemTipo.codigoIntegracaoErp}}
                            </span>
                        </div>
                        <input type="text" class="form-control" [value]="entity.itemTipo.nome" disabled="disable" readonly="readonly">
                    </div>
                    <p class="form-text text-muted">Tipo de produto vinculado a este mercado</p>
                </div>
            </div>
        </div>
    </div>
</form>
